import React from 'react';

export const formatCMErrorsToComponent = text => {
  const lines = text.split('\n').filter(Boolean);
  return lines.map((line, index) => {
    const pipeIndex = line.indexOf('|');
    const lineNumber = line.slice(0, line.indexOf('|')).trim();
    const content = line.slice(pipeIndex + 1);
    return (
      <div key={index}>
        {!content.includes(lineNumber) ? `${lineNumber} |` : ''}
        <span style={{ marginLeft: pipeIndex }}>
          {content?.replaceAll('TEMPLATE', '')}
        </span>
      </div>
    );
  });
};

export const formatResultsToComponent = result => {
  return result.split('\n').map((line, index, array) => (
    <React.Fragment key={index}>
      {line}
      {index === array.length - 1 ? null : <br />}
    </React.Fragment>
  ));
};
